import React from 'react';
import { styles, mobileStyles } from './Style.js';
import { TicTacToe } from './TicTacToe/TicTacToe.js';
import { useIsMobile } from './useIsMobile.js';


class ControlPanel extends React.Component {
    constructor (props) {
        super(props);

        this.handleDelayChange = this.props.handleDelayChange.bind(this);
        this.handlePlayerXChange = this.props.handlePlayerXChange.bind(this);
        this.handleResetAI = this.props.handleResetAI.bind(this);
        this.handleResetStats = this.props.handleResetStats.bind(this);
    }
    render () {
        const controlTitle = this.props.isMobile
            ? {...styles.controlTitle, ...mobileStyles.controlTitle}
            : styles.controlTitle;
        const panelStyle = this.props.isMobile
            ? {...styles.ControlPanel, ...mobileStyles.ControlPanel}
            : styles.ControlPanel;

        return (
            <div style={panelStyle}>
                <div style={styles.player1}>
                    <h2 style={controlTitle}>Player X</h2>
                    <label style={styles.radioRow}>
                        <input type="radio" checked={this.props.playerX == "player"} name="playerX" value="player" onChange={this.handlePlayerXChange} />
                        Me
                    </label>
                    <label style={styles.radioRow}>
                        <input type="radio" checked={this.props.playerX == "dumbCpu"} name="playerX" value="dumbCpu" onChange={this.handlePlayerXChange} />
                        Training bot
                    </label>
                </div>
                <div style={styles.player2}>
                    <h2 style={controlTitle}>Player O</h2>
                    <p style={styles.controlValue}>Learning AI</p>
                </div>
                {/* <div style={styles.delay}>
                    <h2 style={styles.controlTitle}>Computer delay (milliseconds)</h2>
                    <div style={styles.controlContent}>
                    <input style={styles.range} type="range" min="0" max="1000" value={this.props.delay} onChange={this.handleDelayChange} />
                    <p>{this.props.delay}</p>
                    </div>
                </div> */}
                <div style={styles.intellimeter}>
                    <h2 style={controlTitle}>Intellimeter</h2>
                    <div style={styles.meterTrack}>
                        <div style={{...styles.meterFill, width: `${this.props.intellimeter}%`}}></div>
                    </div>
                    <p style={styles.controlValue}>{Math.floor(this.props.intellimeter)}%</p>
                    {/* <button className="ResetAI" onClick={this.handleResetAI}>Reset AI intelligence</button> */}
                </div>
                <div style={styles.stats}>
                    <h2 style={controlTitle}>Stats</h2>
                    <div style={styles.statRow}><span>Player X wins</span><span>{this.props.xwins}</span></div>
                    <div style={styles.statRow}><span>Ties</span><span>{this.props.ties}</span></div>
                    <div style={styles.statRow}><span>Player O wins</span><span>{this.props.owins}</span></div>
                    <button style={styles.resetButton} onClick={this.handleResetStats}>Reset stats</button>
                </div>
            </div>
        );
    }
}

class GameInner extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            xwins: 0,
            owins: 0,
            ties: 0,
            delay: 0,
            playerX: "player", // or "dumbCpu"
            playerO: "smartCpu", // always
            intellimeter: 0,
            AINeedsReset: false,
        };

        this.handleDelayChange = this.handleDelayChange.bind(this);
        this.handleResetAI = this.handleResetAI.bind(this);
        this.handleResetStats = this.handleResetStats.bind(this);
        this.handlePlayerXChange = this.handlePlayerXChange.bind(this);
        this.AIHasBeenReset = this.AIHasBeenReset.bind(this);
        this.winX = this.winX.bind(this);
        this.winO = this.winO.bind(this);
        this.tie = this.tie.bind(this);
        this.updateIntellimeter = this.updateIntellimeter.bind(this);
        this.update = this.update.bind(this);
    }
    handleDelayChange ({target}) {
        this.setState({
            ...this.state,
            delay: target.value
        });
    }
    AIHasBeenReset () {
        this.setState({
            ...this.state,
            AINeedsReset: false
        });
    }
    handleResetAI ({target}) {
        this.AINeedsReset = true;
    }
    handleResetStats ({target}) {
        this.setState({
            ...this.state,
            xwins: 0,
            owins: 0,
            ties: 0
        });
    }
    handlePlayerXChange ({target}) {
        this.setState({
            ...this.state,
            playerX: target.value,
            delay: (target.value == "dumbCpu" ? 3 : 800)
        });
    }

    updateIntellimeter (amount) {
        this.state.intellimeter = amount;
    }

    winX () {
        this.state.xwins += 1;
    }
    winO () {
        this.state.owins += 1;
    }
    tie () {
        this.state.ties += 1;
    }

    update() {
        this.setState({...this.state});
    }

    render () {
        const isMobile = this.props.isMobile;

        return (
            <div style={isMobile ? {...styles.Game, ...mobileStyles.Game} : styles.Game}>
                <ControlPanel
                    isMobile={isMobile}
                    playerX={this.state.playerX}
                    xwins={this.state.xwins}
                    owins={this.state.owins}
                    ties={this.state.ties}
                    delay={this.state.delay}
                    intellimeter={this.state.intellimeter}
                    handleDelayChange={this.handleDelayChange}
                    handlePlayerXChange={this.handlePlayerXChange}
                    handleResetAI={this.handleResetAI}
                    handleResetStats={this.handleResetStats}
                />
                <TicTacToe
                    isMobile={isMobile}
                    winX={this.winX}
                    winO={this.winO}
                    tie={this.tie}
                    AINeedsReset={this.state.AINeedsReset}
                    AIHasBeenReset={this.AIHasBeenReset}
                    playerX={this.state.playerX}
                    playerO={this.state.playerO}
                    delay={this.state.delay}
                    updateIntellimeter={this.updateIntellimeter}
                    updateParent={this.update}
                />
            </div>
        );
    }
}

// Function wrapper so the class above can read the responsive breakpoint hook.
export function Game(props) {
    const isMobile = useIsMobile();
    return <GameInner {...props} isMobile={isMobile} />;
}
